import React, { useEffect } from "react";
import { ClipLoader } from "react-spinners";

const AppsOauth2Redirect = () => {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const status = params.get('status');
        const provider = params.get('provider');
        if (window.opener) {
            window.opener.postMessage(
                {
                    type: 'GOOGLE_OAUTH_SUCCESS',
                    status,
                    provider,
                },
                window.location.origin
            );
            // Add a small delay before closing to ensure the message is received
            setTimeout(() => {
                window.close();
            }, 100);
        }
    }, []);

    return (
        <div>
            <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <ClipLoader size={50} />
            </div>
        </div>
    );
};

export default AppsOauth2Redirect;
